// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"b175a18c","290":"c82cf626","544":"396e2362","550":"fe2f2ac7","740":"c969fc6b"}[chunkId] + ".chunk.js";
};